<template>
   <header>
      <div class="l-content">
         <!--左侧标题-->
         <img src="../assets/login/logo4.png">
         <div class="dot"></div>
         <i class="el-icon-menu" title="折叠/展开菜单" style="font-size: 26px; color:#e6e6e6;" @click="handleMenu"></i>
         <span>{{title}}</span>
      </div>
      <!--右侧-->
      <div class="r-content">
         <img :src="userImg" @click="userImgDialogVisible = true">
         <span>欢迎您</span>
         <span>{{userInfoElse.nickName}}</span>
         <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
               <i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
               <el-dropdown-item command="updatepws">修改密码</el-dropdown-item><!--v-permission="['SYS-USER-REST-OLD']" -->
               <el-dropdown-item command="updatemobile">修改手机号</el-dropdown-item><!-- v-permission="['SYS-USER-SELF-PHONE']"-->
               <el-dropdown-item command="updateinfo" >修改基本信息</el-dropdown-item><!-- v-permission="['SYS-USER-SELF-UPDATE']"-->
               <el-dropdown-item command="quit" >退出</el-dropdown-item>
            </el-dropdown-menu>
         </el-dropdown>
      </div>
      <!--修改密码-->
      <el-dialog
              title="修改密码"
              :visible.sync="pwddialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :destroy-on-close="true"
              width="30%"
              @close="handleClosePwd">
         <!--内容主体区域-->
         <el-form :model="updatePwdForm" :rules="updateUserFormRules" ref="updatePwdFormRef" label-width="120px">
            <el-row>
               <el-col :span="22">
                  <el-form-item label="旧密码：" prop="oldPwd">
                     <el-input type="password" v-model="updatePwdForm.oldPwd"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="新密码：" prop="newPwd">
                     <el-input type="password" v-model="updatePwdForm.newPwd"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="确认新密码：" prop="againPwd">
                     <el-input type="password" v-model="updatePwdForm.againPwd"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
         </el-form>
         <span slot="footer" class="dialog-footer">
          <el-button @click="pwddialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updatePwd1">确 定</el-button>
        </span>
      </el-dialog>
      <!--修改手机号-->
      <el-dialog
              title="修改手机"
              :visible.sync="mobiledialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :destroy-on-close="true"
              width="30%"
              @close="handleClosePwd">
         <!--内容主体区域-->
         <el-form :model="updateMobileForm" :rules="updateUserFormRules" ref="updateMobileFormRef" label-width="120px">
            <el-row>
               <el-col :span="22">
                  <el-form-item label="登录密码：" prop="password">
                     <el-input type="password" v-model="updateMobileForm.password"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="16">
                  <el-form-item label="新手机：" prop="newMobile">
                     <el-input v-model="updateMobileForm.newMobile"></el-input>
                  </el-form-item>
               </el-col>
               <el-col :span="2" :offset="1">
                  <el-button type="primary" @click="getCode" :disabled="this.yanzheng.yzmSeconds<60">{{ yanzheng.yzmButtonText }}</el-button>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="验证码：" prop="code">
                     <el-input v-model="updateMobileForm.code"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
         </el-form>
         <span slot="footer" class="dialog-footer">
          <el-button @click="mobiledialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateMobile">确 定</el-button>
        </span>
      </el-dialog>
      <!--修改基本信息-->
      <el-dialog
              title="修改基本信息"
              :visible.sync="userdialogVisible"
              :close-on-click-modal="false"
              :close-on-press-escape="false"
              :destroy-on-close="true"
              width="30%"
              @close="handleCloseUser">
         <!--内容主体区域-->
         <el-form :model="updateUserForm" :rules="updateUserFormRules" ref="updateUserFormRef" label-width="100px">
            <el-row>
               <el-col :span="22">
                  <el-form-item label="昵称：" prop="nickName">
                     <el-input v-model="updateUserForm.nickName"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="邮箱：" prop="email">
                     <el-input v-model="updateUserForm.email"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="性别：" prop="gender">
                     <el-select v-model="updateUserForm.gender" placeholder="保密" class="width-100">
                        <el-option
                                v-for="item in genders"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                     </el-select>
                  </el-form-item>
               </el-col>
            </el-row>
            <el-row>
               <el-col :span="22">
                  <el-form-item label="地址：" prop="address">
                     <el-input v-model="updateUserForm.address"></el-input>
                  </el-form-item>
               </el-col>
            </el-row>
            <!-- <el-row>
               <el-col :span="4">
                  <el-form-item label="头像：" prop="avatar">
                     <el-avatar :size="50" :src="updateUserForm.avatar"></el-avatar>
                  </el-form-item>
               </el-col>
            </el-row> -->

         </el-form>
         <span slot="footer" class="dialog-footer">
          <el-button @click="userdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="updateUser">确 定</el-button>
         </span>
      </el-dialog>
      <!--修改头像-->
      <el-dialog title="修改头像"
                 :visible.sync="userImgDialogVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 :destroy-on-close="true"
                 width="20%"
                 @close="userImgDialogVisible = false" class="touxiang">
         <el-form>
            <el-form-item label="" prop="">
               <el-upload
                       class="avatar-uploader"
                       :class="{hide:hideUploadIcon}"
                       ref="upload"
                       :action="''"
                       :multiple="false"
                       :on-preview="handlePreview"
                       :on-remove="handleRemove"
                       :limit="1"
                       :on-change="onchange"
                       :show-file-list="false"
                       :auto-upload="false">
                  <img v-if="updataImgForm.imgUrl" :src="updataImgForm.imgUrl" class="avatar">
                  <img v-else :src="userImg" class="avatar">
                  <!--<i class="el-icon-plus"></i>-->
               </el-upload>
               <el-button @click="userImgDialogVisible = false" >取 消</el-button>
               <el-button type="primary" @click="saveIco()" >提 交</el-button>
            </el-form-item>
         </el-form>
      </el-dialog>
   </header>
</template>

<script>
import { mapGetters } from 'vuex'
import { updatepwd, updateUserSelf, updateHeadImgSelf, updateMobile } from '@/api/user'
import { checkMobile } from '@/utils/rule'
/*, samePwd*/
import { sendMsg } from '@/api/sms'

export default {
   name: "MyHeader",
   props: {
      tag:{
         type: String,
         default: '0'
      },
      title:{
         type: String,
         default: ''
      }
   },
   data() {
      // 验证手机
      const genders = [
         {value: 1, label: '男'},
         {value: 0, label: '女'},
         {value: 2, label: '保密'}
      ]
      return {
         // userImg: '',
                 // require('../assets/header/699pic_0btbtt_xy@2x.png'),
         // username: this.$store.state.username,
         fileList: [],
         pwddialogVisible: false,
         updatePwdForm: {
            oldPwd: 'root999',
            newPwd: 'root999',
            againPwd: 'root999',
            uid: this.uid
         },
         userdialogVisible: false,
         genders,
         updateUserForm: {
            nickName: 'root',
            avatar: '',
            uid: this.uid,
            email: '',
            gender: 0,
            address: ''
         },
         /*updateUserFormRules: {
            phonenum: [
               { required: true, message: '请输入手机号', trigger: 'blur' },
               { validator: checkMobile, trigger: 'blur' }
            ],
            newPwd: [
               { required: true, message: '请输入新密码', trigger: 'blur' },
               //{ validator: samePwd, trigger: 'blur' }
            ],
            againPwd: [
               { required: true, message: '请确认新密码', trigger: 'blur' },
               { validator: this.samePwd, trigger: 'blur' }
            ],
            nickName: [
               { required: true, message: '请输入昵称', trigger: 'blur' }
            ],
            newMobile: [
               { required: true, message: '请输入新手机号', trigger: 'blur' }
            ],
            code: [
               { required: true, message: '请输入验证码', trigger: 'blur' }
            ]
         },*/
         updataImgForm: {
            imgUrl: '',
            imgname: '',
            file: ''
         },
         userImgDialogVisible: false,
         param: {},
         hideUploadIcon: true,
         mobiledialogVisible: false,
         updateMobileForm: {
            password: '',
            // oldMobile: '',
            newMobile: '',
            code: ''
         },
         yanzheng: {
            yzmSeconds: 60,
            yzmButtonText: '获取验证码',
            isSendYzm: false,
            sendTimes: 0
         }
      }
   },
   methods: {
      handleCommand(command) {
         if (command === 'updatepws') {
            this.pwddialogVisible = true
         }
         if (command === 'updatemobile') {
            this.mobiledialogVisible = true
         }
         if (command === 'updateinfo') {
            this.updateUserForm.avatar = this.userImg
            // console.log(this.setUserInfoElse)
            this.updateUserForm.nickName = this.setUserInfoElse.nickName
            this.updateUserForm.email = this.setUserInfoElse.email
            this.updateUserForm.gender = this.setUserInfoElse.gender
            this.updateUserForm.address = this.setUserInfoElse.address
            this.userdialogVisible = true
         }
         if (command === 'quit') {
            console.log('执行退出操作')
            if(this.tag==='1'){
                //console.log(window.location)
                //window.location.assign(window.location.origin)

               // window.opener = null
               // window.open('about:blank','_top').close()
                console.log(this.$store)
                this.$store.dispatch('user/logout').then(() => {
                    window.location.assign(window.location.origin)
                })
            }else{
               this.$store.dispatch('user/logout').then(() => {
                  this.$router.push('/login')
               })
            }
         }
         // this.$message('click on item ' + command);
      },
      handleClosePwd() {
         this.pwddialogVisible = false
      },
      handleCloseUser() {
         this.userdialogVisible = false
      },
      updatePwd1() {
          console.log(this.updatePwdForm)
          this.$refs.updatePwdFormRef.validate(async valid => {
            if (!valid) return
            this.updatePwdForm.uid = this.uid
            updatepwd(this.updatePwdForm).then(response => {
               console.log(response)
               if (response.code != 200)
                  return this.$message.error(response.msg)
               this.$message.success(response.msg)
               this.pwddialogVisible = false
               const that = this
               setTimeout(function () {
                  that.$store.dispatch('user/logout').then(() => {
                     that.$router.push('/login')
                  })
               }, 2000)
            })
         })
      },
      updateUser() {
         this.$refs.updateUserFormRef.validate(async valid => {
            if (!valid) return
            this.updateUserForm.uid = this.uid
            console.log(this.updateUserForm)
            updateUserSelf(this.updateUserForm).then(response => {
               console.log(response)
               if (response.code != 200){
                  return this.$message.error(response.msg)
               }else{
                  this.$message.success(response.msg)
                  this.userdialogVisible = false
                  this.$store.dispatch('user/getInfo')
               }
            })
         })
      },
      handlePreview(file) {
         console.log(file)
      },
      handleRemove(){

      },
      handleExceed(files, fileList) {
         console.log(this.fileList)
         this.$message.warning(`当前限制选择 2 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeAvatarUpload(file) {
         const isJPG = file.type === 'image/jpeg'
         const isLt2M = file.size / 1024 / 1024 < 2

         if (!isJPG) {
            this.$message.error('上传头像图片只能是 JPG 格式!');
         }
         if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
         }
         if (isJPG && isLt2M) {
            this.updataImgForm.imgname = file.name
            // this.updateUserForm.avatar = require('')
            //创建临时的路径来展示图片
            var windowURL = window.URL || window.webkitURL
            this.updataImgForm.imgUrl = windowURL.createObjectURL(file)

            this.param = new FormData();
            this.param.append('imgFile', file);
            // var names = this.form.imgFile; , file.imgFile
            //下面append的东西就会到form表单数据的fields中；
            for (var key in this.updataImgForm){
               this.param.append(key, this.updataImgForm[key]);
            }
            var _this = this
            var event = event || window.event
            var f = event.target.files[0]
            var reader = new FileReader()
            //转base64
            reader.onload = function(e) {
               _this.updataImgForm.imgUrl = e.target.result //将图片路径赋值给src
            }
            reader.readAsDataURL(f)
         } else {
            console.log('false')
           return false
         }
      },
      //当上传图片后，调用onchange方法，获取图片本地路径
      onchange(file,fileList){
         console.log('onchange')
         console.log(file,fileList)
         const isJPG = file.raw.type === 'image/jpeg'
         const isPNG = file.raw.type === 'image/png'
         const isLt2M = file.size / 1024 / 1024 < 2
         this.hideUploadIcon = fileList.length >= 1
         if (!isPNG && !isJPG) {
            this.$message.error('上传图片只能是 JPG/PNG 格式!')
            return false
         } else if (!isLt2M) {
            this.$message.error('上传图片大小不能超过 2MB!')
            return false
         } else if (isLt2M && (isPNG || isJPG)) {
            var _this = this
            // var event = event || window.event
            var f = file.raw
                    // event.target.files[0]
            var reader = new FileReader()
            //转base64
            reader.onload = function(e) {
               _this.updataImgForm.imgUrl = e.target.result //将图片路径赋值给src
            }
            reader.readAsDataURL(f)
            //this.updataImgForm.imgUrl = file.raw //图片的url
            this.updataImgForm.imgname = file.name //图片的名字
            this.updataImgForm.file = file.raw
            console.log(this.updataImgForm)
         }
      },
      handleAvatarSuccess(res, file) {
         console.log(file)
      },
      saveIco(){
         /*for (var key in this.updataImgForm){
            this.param.append(key, this.updataImgForm[key]);
         }*/
         this.param = new FormData()
         this.param.append('file',this.updataImgForm.file)
         updateHeadImgSelf(this.param).then(response => {
            console.log(response)
            if (response.code != 200)
               return this.$message.error(response.msg)
            this.$message.success(response.msg)
            this.userImgDialogVisible = false
            this.$store.dispatch('user/getInfo')
         })
      },
      getCode() {
         console.log('新手机号',this.updateMobileForm.newMobile)
         // 这里需要给手机号发送验证码，接口待对接
         sendMsg({mobile: this.updateMobileForm.newMobile}).then(response => {
            console.log('发送验证码',response)
            if (response.code != 200)
               return this.$message.error(response.msg)
            this.yanzheng.isSendYzm = true
            let clock = window.setInterval(() => {
               this.yanzheng.yzmSeconds--
               this.yanzheng.yzmButtonText = '已发送（' + this.yanzheng.yzmSeconds + '）'
               if (this.yanzheng.yzmSeconds < 1) {
                  window.clearInterval(clock)
                  this.yanzheng.yzmSeconds = 60
                  this.yanzheng.isSendYzm = false
                  this.yanzheng.yzmButtonText = '再次发送'
                  if (++this.yanzheng.sendTimes > 2) {
                     this.yanzheng.yzmButtonText = '发送次数已达到3'
                     this.yanzheng.isSendYzm = true
                     this.yanzheng.yzmSeconds = 0
                  }
               }
            }, 1000)
            return
            // this.$message.success(response.msg)
         })
      },
      updateMobile() {
         this.$refs.updateMobileFormRef.validate(async valid => {
            if (!valid) return
            updateMobile(this.updateMobileForm).then(response => {
               console.log('替换手机号', response)
               if (response.code != 200){
                  return this.$message.error(response.msg)
               }else{
                  this.mobiledialogVisible = false
                  this.$store.dispatch('user/getInfo')
                  return this.$message.success(response.msg)
               }
            })
         })
      },
      handleMenu () {
         this.sidebar.opened = !this.sidebar.opened
      },
      samePwd(rule, value, cb) {
          if(this.updatePwdForm.newPwd === this.updatePwdForm.againPwd){
              return cb()
          }
          return cb(new Error('新密码2次输入要一致'))
      }
   },
   computed: {
      ...mapGetters([
         'avatar',
         'name',
         'uid',
         'token',
         'userInfoElse',
         'sidebar'
      ]),
      userImg() {
         if (this.avatar === 'undefined' || this.avatar === undefined || this.avatar === ''){
            // console.log('this.avatar=' + this.avatar)
            return require('@/assets/header/699pic_0btbtt_xy@2x.png')
         }
         //return require('@/' + this.avatar)
         return this.COMMON.httpUrl + '/static' + this.avatar + '?token=Bearer '+ this.token
      },
      setUserInfoElse() {
         // console.log(this.userInfoElse)
         return this.userInfoElse
      },
       updateUserFormRules: function(){
          let arr={}
           arr.phonenum=[
               { required: true, message: '请输入手机号', trigger: 'blur' },
               { validator: checkMobile, trigger: 'blur' }
           ],
               arr.newPwd= [
               { required: true, message: '请输入新密码', trigger: 'blur' },
               //{ validator: samePwd, trigger: 'blur' }
           ],
               arr.againPwd= [
               { required: true, message: '请确认新密码', trigger: 'blur' },
               { validator: this.samePwd, trigger: 'blur' }
           ],
               arr.nickName= [
               { required: true, message: '请输入昵称', trigger: 'blur' }
           ],
               arr.newMobile= [
               { required: true, message: '请输入新手机号', trigger: 'blur' }
           ],
               arr.code= [
               { required: true, message: '请输入验证码', trigger: 'blur' }
           ]
           return arr
       }
   },
   created() {
      /*this.setUserInfoElse()*/
   }
}
</script>

<style lang="scss" scoped>
.width-100 {
   width: 100%;
}
   header {
      background-color: #1F2431 ;
      padding: 0 20px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
   }
   .l-content {
      display: flex;
      align-items: center;
      .dot {
         margin: 0 10px;
         border: 1px solid #ecf5ff;
      }
      i {
         cursor: pointer;
      }
      span{
         color:white;
         font-size: 1.4em;
         margin-left: 40px;
      }
   }
   .r-content {
      display: flex;
      align-items: center;
      img {
         width: 30px;
         height: 30px;
         border-radius: 50%;
      }
      span {
         color: white;
         margin-left: 10px;
      }
   }
   .get-code ::v-deep {
      .el-form-item__content{
         margin-left: 20px!important;
      }
   }
   .touxiang {
      .el-dialog .el-dialog__body{
         display: flex;
         justify-content: center;
         align-items: center;
      }
      .avatar {
         width: 80px;
         height: 80px;
      }
   }

</style>
